import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingWhatsAppButton from "../components/FloatingWhatsAppButton";
import FloatingPhoneButton from "../components/FloatingPhoneButton";
import LandingNavbar from "../components/LandingNavbar";

const MainLayout = () => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, [location.pathname]);

  // Show LandingNavbar only on /destination/:countryName pages
  const isLandingPage = location.pathname.startsWith("/destination/");

  return (
    <>
      {isLandingPage ? <LandingNavbar /> : <Navbar />}
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingPhoneButton />
      <FloatingWhatsAppButton />
    </>
  );
};

export default MainLayout;
